import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/**
 * `GET /trades` returns the exact same `ExecutionOrderDto` shape as
 * `GET /orders` (backend/src/api/routes/orders.py) - there is no distinct,
 * persisted Trade record exposed via REST today. `tradeService` wraps this
 * honestly rather than inventing a richer trade model client-side.
 */
export const tradeService = {
  async getTradeBook(): Promise<ApiRecord[]> {
    const response = await apiClient.get<ApiRecord[]>(endpoints.executions.tradeBook);
    return response.data;
  },
};
